<template>
  <div class="panel-body">
    <div class="left">
      <base-table
        :url="'Affiliater/list'"
        :columns="$options.affiliaterColumns"
        :need-loading="false"
      >
        <template slot="createdDate" slot-scope="props">
          <span>{{ formatCreatedDate(props.rowData.createdDate) }}</span>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import BaseTable from '@/components/BaseTable'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    BaseTable
  },
  affiliaterColumns: [
    {
      title: '登録日付',
      name: 'createdDate',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-md-3'
    },
    {
      title: '会社名 / 担当者',
      name: 'name',
      cellClass: 'text-left',
      headerClass: 'col-md-7'
    },
    {
      title: '状態',
      name: 'status',
      cellClass: 'text-center',
      headerClass: 'col-md-2'
    }
  ],
  data () {
    return {
      column: null,
      sort: null,
      apiDone: [],
      loader: null
    }
  },
  created () {
    this.loader = this.$loading.show()
  },
  mounted () {
    this.$events.listen('done', (url) => {
      if (!this.apiDone.includes(url)) {
        this.apiDone.push(url)
      }
    })

    if (this.currentTab && this.currentTab === 'affiliater-list') {
      let logParams = {
        name: eventCode.affiliate.list_affiliate_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  watch: {
    apiDone (newVal) {
      if (newVal.length === 1 && this.loader) {
        this.loader.hide()
      }
    }
  },
  methods: {
    formatCreatedDate (value) {
      return moment(value).format('YYYY/MM/DD')
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
@media (max-width: 425px) {
  .panel-body /deep/ .table-wrapper {
    overflow-x: auto !important;
  }
  .panel-body /deep/ .table-wrapper .table {
    min-width: 700px !important;
    max-width: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/affiliate/AffiliaterList.vue